<template>
<div class="container col-lg-10 col-md-10">
  <CTabs variant="tabs" :active-tab.sync="activeTab">
    <CTab title="New Organisation">
      <AddOrganisation v-if="activeTab === 0" @submit="registerOrganisation"/>
    </CTab>
    <CTab title="Partner Organisation">
      <PartnerOrganisation v-if="activeTab === 1" @submit="registerOrganisation"/>
    </CTab>
  </CTabs>
</div>
</template>
<script>
import AddOrganisation from "@/containers/Organisation/AddOrganisation";
import PartnerOrganisation from "@/containers/Organisation/PartnerOrganisation";
import { mapActions } from 'vuex';
export default {
  components: {
    AddOrganisation,
    PartnerOrganisation,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  methods:{
    ...mapActions(["addOrganisation"]),
    registerOrganisation(data){
      this.addOrganisation(data);
    }
  }
};
</script>